import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Reports from './pages/Reports';
import UserManagement from './pages/UserManagement';
import Sales from './pages/Sales';
import Deposit from './pages/Deposit';
import CreditRegister from './pages/CreditRegister';
import Transactions from './pages/Transactions';
import ProductOrder from './pages/ProductOrder';
import OrderHistory from './pages/OrderHistory';
import LowStockManagement from './pages/LowStockManagement';
import Spending from './pages/Spending';
import CarwashReport from './pages/CarwashReport';
import InstitutionalSpending from './pages/InstitutionalSpending';
import WorkersCredit from './pages/WorkersCredit';
import VehicleManagement from './pages/VehicleManagement';
import CarwashTransaction from './pages/CarwashTransaction';
import CarWashSpending from './pages/CarWashSpending';
import Categories from './pages/Categories';
import SpareSpending from './pages/SpareSpending';
import Notes from './pages/Notes';
import MainLayout from './layout/MainLayout';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset" element={<ResetPassword />} />

          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="sales" element={<Sales />} />
            <Route path="credit-register" element={<CreditRegister />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="product-order" element={<ProductOrder />} />
            <Route path="order-history" element={<OrderHistory />} />
            <Route path="vehicle-management" element={<VehicleManagement />} />
            <Route path="carwash-transaction" element={<CarwashTransaction />} />
            <Route path="spending" element={<Spending />} />
            <Route path="institutional-spending" element={<InstitutionalSpending />} />
            <Route path="workers-credit" element={<WorkersCredit />} />
            <Route path="carwash-report" element={<CarwashReport />} />
            <Route path="carwash-spending" element={<CarWashSpending />} />
            <Route path="deposit" element={<Deposit />} />
            <Route path="reports" element={<Reports />} />
            <Route path="categories" element={<Categories />} />
            <Route path="spare-spending" element={<SpareSpending />} />
            <Route path="low-stock" element={<LowStockManagement />} />
            <Route path="notes" element={<Notes />} />
            <Route path="settings" element={<UserManagement />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
